import React from "react";
import { Box, ButtonBase, Typography } from "@mui/material";
import { useLanguage } from "../../contexts/LanguageContext";

interface Props {
  /** "light" = white text (for dark navbars), "dark" = navy text (for white navbars) */
  variant?: "light" | "dark";
}

const LanguageSwitcher: React.FC<Props> = ({ variant = "dark" }) => {
  const { language, setLanguage } = useLanguage();

  const color = variant === "light" ? "rgba(255,255,255,0.7)" : "#78909C";
  const activeColor = variant === "light" ? "#fff" : "#0A1628";
  const activeBg    = variant === "light"
    ? "rgba(255,255,255,0.15)"
    : "rgba(21,101,192,0.10)";
  const border      = variant === "light"
    ? "1px solid rgba(255,255,255,0.2)"
    : "1px solid rgba(21,101,192,0.2)";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        border,
        borderRadius: "8px",
        overflow: "hidden",
        flexShrink: 0,
      }}
    >
      {(["en", "ar"] as const).map((lang) => {
        const isActive = language === lang;
        return (
          <ButtonBase
            key={lang}
            onClick={() => setLanguage(lang)}
            sx={{
              px: 1.4,
              py: 0.55,
              bgcolor: isActive ? activeBg : "transparent",
              transition: "all .2s ease",
              "&:hover": { bgcolor: activeBg, opacity: 0.85 },
            }}
          >
            <Typography
              sx={{
                fontSize: ".75rem",
                fontWeight: isActive ? 800 : 500,
                color: isActive ? activeColor : color,
                letterSpacing: lang === "en" ? ".04em" : 0,
                fontFamily: lang === "ar" ? "'Cairo', sans-serif" : "inherit",
                lineHeight: 1,
              }}
            >
              {lang === "en" ? "EN" : "ع"}
            </Typography>
          </ButtonBase>
        );
      })}
    </Box>
  );
};

export default LanguageSwitcher;
